import { Element, Node } from 'slate';
import { StyledParagraphElement } from 'slate/types/slate';

export const isStyledParagraph = (node: Node): node is StyledParagraphElement => Element.isElement(node) && node.type === 'styled-paragraph';
